import type { FaireProductEntity } from "../../entity_types/product";

export const p_h793nte9dz: FaireProductEntity = {
  token: "p_h793nte9dz",
  type: "product",
  name: "Wild Herb Tonic - Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6e1c3290c7e53ececa9475d28472605a1ef4e7e4d1965214667067b296033f8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6443ea3458f3f857047890a89575b4f7b674efaca56a297aa1b28de8089ef519.jpeg",
    "https://cdn.faire.com/fastly/6221a4e8c6fda38602d17f36a01c89591f92b5d16228d47370f0bdfd1ec9bbe2.png",
    "https://cdn.faire.com/fastly/91c0f84eac41fd0ea6f233c05ae7bfe2c6d9787569d4d4ced5f3d713276df01a.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/9d0bd272bd3218e678e2ad4d572062a04d096c083b603c5391706273149cb761.jpeg",
    "https://cdn.faire.com/fastly/41db24fd9063c264330da38383dae63613a26b7f136eac29b3b925821c80ec91.jpeg",
  ],
  priceDollars: 5,
  description:
    'Barefoot walks through wild herb gardens, cool mountain stream baths, crisp morning air. Lemon balm, thyme, orange, fir.\n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:50.790Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
